export const LEFT_MARGIN = 60
export const RIGHT_MARGIN = 50
export const TOP_MARGIN = 30
export const NUMERIC_VALUE_MARGIN = 140
export const MULTI_GRAPH_SPACING = 7
export const TIMELINE_SPACING = 15
export const MODALITY_LABEL_FONT_SIZE = "12px"
export const AXIS_TICK_FONT_SIZE = "10px"